//bao migrate skip
import * as ko from "knockout";
import * as $ from "jquery";
import * as c3 from "c3";

class C3Binding {
    public config = {
        chartObject: ko.observable(),
        data: {},
        bindto: null
    }
    public accurateCompare(obj1, obj2) {
        return JSON.stringify(obj1) === JSON.stringify(obj2);
    }
    public chart: KnockoutObservable<any>;
}

ko.bindingHandlers.c3chart = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        $(element).css("min-width", "500px");
        var vm = new C3Binding();
        $.extend(vm.config, ko.toJS(valueAccessor()));
        if (!ko.isObservable(vm.config.chartObject)) {
            vm.config.chartObject = ko.observable();
        }
        vm.chart = vm.config.chartObject;
        vm.config.bindto = element;

        const chart = c3.generate(vm.config);
        vm.chart(chart);
        $(element).data("c3chart", vm);

    },
    update: function (element, valueAccessor, allBindings, viewModel) {
        var configUpdated = ko.toJS(valueAccessor());
        var vm = $(element).data("c3chart");
        if (typeof configUpdated !== "object") {
            return;
        }
        if (typeof configUpdated.data === "object") {
            if (!vm.accurateCompare(configUpdated.data, vm.config.data)) {
                setTimeout(() => {
                    vm.chart().unload();
                    vm.chart().load(ko.map.toJS(configUpdated.data));
                    vm.chart().flush();
                }, 1000);
            }
        }
        $.extend(vm.config, configUpdated);
    }
};